import { Component, Prop } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';

@Component
export default class InputText extends InputBase<string> {
  // default maxlength of an input:  https://www.w3schools.com/tags/att_input_maxlength.asp
  @Prop({default: 524288, required: false}) public maxlength?: number;
  protected mounted() {
    this.inputType = 'text';
  }
}
